import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'

import ApplicationReview from '@/views/ApplicationReview'
import ApplicationReviewDetail from '@/views/ApplicationReviewDetail'
import NonAssignedApplicationReviewDetail from '@/views/NonAssignedApplicationReviewDetail'
import ApplicationReportDetail from '@/views/ApplicationReportDetail'

import EvaluationsOverview from '@/views/EvaluationsOverview'
import SubmissionsOverview from '@/views/SubmissionsOverview'
import StaffSubmissionReports from '@/views/StaffSubmissionReports'

import EvaluatorsOverview from '@/views/EvaluatorsOverview'
import EvaluatorsStatusOverview from '@/views/EvaluatorsStatusOverview'
import EvaluatorsEmailOverview from '@/views/EvaluatorsEmailOverview'
import EvaluatorOverviewByPreference from '@/views/EvaluatorOverviewByPreference'
import EvaluatorOverviewByTag from '@/views/EvaluatorOverviewByTag'
import EvaluatorDetail from '@/views/EvaluatorDetail'

import StaffAddEvaluator from '@/views/StaffAddEvaluator'
import StaffEvaluatorReports from '@/views/StaffEvaluatorReports'
import MagicLink from '@/views/MagicLink'
import MagicLinkReport from '@/views/MagicLinkReport'
import StaffApplicationReviewDetail from '@/views/StaffApplicationReviewDetail'
import StaffApplicationReviewDetailEdit from '@/views/StaffApplicationReviewDetailEdit'
import StaffEditPreferences from '@/views/StaffEditPreferences'
import StaffRenamePreferences from '@/views/StaffRenamePreferences'
import StaffReportGeneration from '@/views/StaffReportGeneration'
import StaffUploadEvaluators from '@/views/StaffUploadEvaluators'
import StaffUploadApplications from '@/views/StaffUploadApplications'
import StaffUploadApplicationFiles from '@/views/StaffUploadApplicationFiles'

import Auth from '@/services/auth'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/magic-link',
      name: 'MagicLink',
      component: MagicLink,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/magic-link-report',
      name: 'MagicLinkReport',
      component: MagicLinkReport,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/',
      name: 'Home',
      component: ApplicationReview,
      beforeEnter: Auth.requireAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/applications',
      name: 'ApplicationReview',
      component: ApplicationReview,
      beforeEnter: Auth.requireAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/applications/assigned/:applicationId',
      name: 'ApplicationReviewDetail',
      component: ApplicationReviewDetail,
      beforeEnter: Auth.requireAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/applications/non-assigned/:applicationId',
      name: 'NonAssignedApplicationReviewDetail',
      component: NonAssignedApplicationReviewDetail,
      beforeEnter: Auth.requireAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/application-reports/:applicationId',
      name: 'ApplicationReportDetail',
      component: ApplicationReportDetail,
      beforeEnter: Auth.requireAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/evaluations/',
      name: 'EvaluationsOverview',
      component: EvaluationsOverview,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/submissions/reports',
      name: 'StaffSubmissionReports',
      component: StaffSubmissionReports,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/submissions/',
      name: 'SubmissionsOverview',
      component: SubmissionsOverview,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/evaluators/',
      name: 'EvaluatorsOverview',
      component: EvaluatorsOverview,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/status-overview/',
      name: 'EvaluatorsStatusOverview',
      component: EvaluatorsStatusOverview,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/evaluators/add-staff/',
      name: 'StaffAddEvaluator',
      component: StaffAddEvaluator,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/email-evaluators/',
      name: 'EvaluatorsEmailOverview',
      component: EvaluatorsEmailOverview,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/evaluators/:evaluatorId',
      name: 'EvaluatorDetail',
      component: EvaluatorDetail,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/evaluators/preferences/:preferenceId',
      name: 'EvaluatorOverviewByPreference',
      component: EvaluatorOverviewByPreference,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/evaluators/tags/:tagId',
      name: 'EvaluatorOverviewByTag',
      component: EvaluatorOverviewByTag,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/evaluators/reports',
      name: 'StaffEvaluatorReports',
      component: StaffEvaluatorReports,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/application/:applicationId',
      name: 'StaffApplicationReviewDetail',
      component: StaffApplicationReviewDetail,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/application/edit/:applicationId',
      name: 'StaffApplicationReviewDetailEdit',
      component: StaffApplicationReviewDetailEdit,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/preferences/edit/',
      name: 'StaffEditPreferences',
      component: StaffEditPreferences,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/preferences/edit/:preferenceId',
      name: 'StaffRenamePreferences',
      component: StaffRenamePreferences,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/report-generation/:applicationId',
      name: 'StaffReportGeneration',
      component: StaffReportGeneration,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/upload-evaluators',
      name: 'StaffUploadEvaluators',
      component: StaffUploadEvaluators,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/upload-proposals',
      name: 'StaffUploadApplications',
      component: StaffUploadApplications,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
    {
      path: '/staff/upload-proposal-files',
      name: 'StaffUploadApplicationFiles',
      component: StaffUploadApplicationFiles,
      beforeEnter: Auth.requireStaffAuth,
      meta: {
        validateTokenOnRefresh: true,
      },
    },
  ],
})
